import React from 'react';
import { useComparison } from '../contexts/ComparisonContext';
import './ComparisonButton.css';

interface ComparisonButtonProps {
  type: 'country' | 'company' | 'job';
  item: any;
  className?: string;
}

const ComparisonButton: React.FC<ComparisonButtonProps> = ({ type, item, className }) => {
  const { addToComparison, removeFromComparison, isInComparison, canAddToComparison } = useComparison();
  
  // Add null check for item
  if (!item) {
    console.error('ComparisonButton: item is null or undefined');
    return null;
  }
  
  const itemId = type === 'country' ? item.code : item.id;
  if (!itemId) {
    console.error(`ComparisonButton: ${type} item missing ${type === 'country' ? 'code' : 'id'}`, item);
    return null;
  }
  
  const isAdded = isInComparison(type, itemId);
  const canAdd = canAddToComparison(type);
  
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    // console.log(`[ComparisonButton] Clicked for ${type}:`, item);
    // console.log(`[ComparisonButton] Item ID: ${itemId}, Is added: ${isAdded}, Can add: ${canAdd}`);
    
    if (isAdded) {
      // console.log(`[ComparisonButton] Removing ${type} with id: ${itemId}`);
      removeFromComparison(type, itemId);
    } else if (canAdd) {
      // console.log(`[ComparisonButton] Adding ${type} to comparison`);
      addToComparison(type, item);
    } else {
      // console.log(`[ComparisonButton] Cannot add - max items reached`);
    }
  };
  
  return (
    <button
      className={`comparison-button ${isAdded ? 'added' : ''} ${!canAdd && !isAdded ? 'disabled' : ''} ${className || ''}`}
      onClick={handleClick}
      title={
        isAdded 
          ? 'Remove from comparison' 
          : !canAdd 
          ? 'Maximum items reached' 
          : 'Add to comparison'
      }
      disabled={!canAdd && !isAdded}
    >
      <span className="material-icons">
        {isAdded ? 'remove_circle' : 'add_circle'}
      </span>
      <span className="button-text">
        {isAdded ? 'Remove' : 'Compare'}
      </span>
    </button>
  );
};

export default ComparisonButton;